module.exports = __webpack_public_path__ + "img/bn0713.3753e167.png";